import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, TextField, SelectField, MenuItem } from "material-ui"
import strings from "../../../localization/strings"
import { IAccrualAdjustment } from "../../../models"

interface IProps {
    adjustments: IAccrualAdjustment[]
    balance: string
    isNoteRequired: boolean
    isAdjustmentReasonRequired: boolean
    handleClose(): void
    updateBalance(updatedValue: string): void
    setNote(value: string): void
    setAdjustmentReason(value: IAccrualAdjustment): void
}
interface IState {
    balance: string
    note: string
    selectedAdjustmentReason: IAccrualAdjustment
    selectedAdjustmentValue: number
    errorNote: string
    errorAdjustmentReason: string
}

export default class AddManualAdjustmentDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            balance: props.balance,
            note: "",
            selectedAdjustmentReason: undefined,
            selectedAdjustmentValue: 0,
            errorNote: "",
            errorAdjustmentReason: "",
        }
        autobind(this)
    }

    componentWillReceiveProps (newProps) {
        if(this.props.balance !== newProps.balance) {
            this.setState({ balance: newProps.balance })
        }
    }
	
	handleSave() {
        if (this.checkValidate()) {
            const updatedBalance = Number(this.props.balance) + Number(this.state.selectedAdjustmentValue)
            this.props.updateBalance(updatedBalance.toString())
            this.props.setNote(this.state.note)
            this.props.setAdjustmentReason(this.state.selectedAdjustmentReason)
            this.props.handleClose()
        }
    }
    
    checkValidate() {
		let isValidate = true
		if (!this.state.note.trim() && this.props.isNoteRequired) {
			this.setState({ errorNote: strings.This_field_is_required })
			isValidate = false
		}
		else {
			this.setState({ errorNote: "" })
        }

        if (this.state.selectedAdjustmentReason === undefined && this.props.isAdjustmentReasonRequired) {
			this.setState({ errorAdjustmentReason: strings.This_field_is_required })
			isValidate = false
		}
		else {
			this.setState({ errorAdjustmentReason: "" })
        }
        return isValidate
	}

    render() {
        return (
            <Dialog
                open
                title={strings.Manual_Accrual_Adjustment}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
                actions={[
                <FlatButton
                    data-intercom-target={"menu-Employees-Accruals-Adjustment-Btn-CloseAjustmentDialog"}
                    label={strings.CANCEL}
                    secondary
                    onClick={this.props.handleClose}
                />,
                <FlatButton
                     data-intercom-target={"menu-Employees-Accruals-Adjustment-Btn-SaveAdjustment"}
                    label={strings.SAVE}
                    primary
                    onClick={this.handleSave}
                />
                ]}
            >
                <div style={{ paddingRight: 20, paddingLeft: 20 }}>
                    <TextField 
                        data-intercom-target={"menu-Employees-Accruals-Adjustment-Entry-CurrentValue"}
                        floatingLabelText={strings.Current_Value}
                        value={this.state.balance}
                        disabled
                    />
                    <div style={{ display: "flex" }}>
                        <SelectField
                            data-intercom-target={"menu-Employees-Accruals-Adjustment-Select-AdjustmentReason"}
                            floatingLabelText={strings.Adjustment_Reason}
                            value={this.state.selectedAdjustmentReason}
                            onChange={(event, key, value) => {
                                this.setState({ selectedAdjustmentReason: value, selectedAdjustmentValue: value.AdjustmentValue }, () => this.checkValidate())
                            }}
                            style={{ width: "90%", marginRight: 10 }}
                            errorText={this.state.errorAdjustmentReason}
                            errorStyle={{ position: "absolute", bottom: -10 }}
                        >
                            {this.props.adjustments
                                .map((item, index) =>
                                    <MenuItem key={index} value={item} primaryText={item.Adjustment} />
                                )
                            }
                        </SelectField>
                        <TextField
                             data-intercom-target={"menu-Employees-Accruals-Adjustment-Entry-Adjustment"}
                            type={"number"}
                            floatingLabelText={strings.Adjustment}
                            value={this.state.selectedAdjustmentValue || ""}
                            onChange={(e, value) => this.setState({ selectedAdjustmentValue: value }, () => this.checkValidate()) }
                            style={{ width: "10%" }}
                            disabled={this.state.selectedAdjustmentReason !== undefined ? false : true}
                        />
                    </div>
                    <TextField
                         data-intercom-target={"menu-Employees-Accruals-Adjustment-Entry-Note"}
                        floatingLabelText={strings.Note}
                        value={this.state.note}
                        onChange={(e, value) => this.setState({ note: value }, () => this.checkValidate()) }
                        errorText={this.state.errorNote}
                        errorStyle={{ position: "absolute", bottom: -10 }}
                        fullWidth={true}
                    />
                </div>
            </Dialog>
        )
    }
}